module.exports = __webpack_public_path__ + "img/info1.ca3115c8.png";